import React from "react";
import "../../css/pressview.css";
import Heading from "../../components/Heading";
import { pressContent } from "../../constant/blogConstant";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import VideoPopup from "../../components/videopopup";

export class press extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      currentVideoLink: "",
      showVideo: false,
      currentText: "",
    };
  }

  toggleVideo = () => {
    this.setState({ showVideo: !this.state.showVideo });
  };

  playCurrentVideo = (video, text) => {
    this.setState({ currentVideoLink: video, currentText: text }, () => {
      this.toggleVideo();
    });
  };

  render() {
    const { location } = this.props;

    const pressJSX = pressContent.map((item, i) => {
      if (item.type === "link") {
        return (
          <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="Bcard" key={i}>
              <a href={item.link} target="_blank">
                <div className="blog_card">
                  <div className="card_img">
                    <img src={item.bimg} alt={item.title} />
                  </div>
                  <div className="bcard_content">
                    <div className="Press_heading_top">{item.pname}</div>
                    <div className="card_heading1">{item.title}</div>
                    <div className="card_date">{item.date}</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        );
      } else if (item.type === "video") {
        return (
          <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div
              className="Bcard"
              onClick={() => this.playCurrentVideo(item.link, item.title)}
              key={i}
              style={{ cursor: "pointer" }}
            >
              <div className="blog_card">
                <div className="card_img">
                  <img src={item.bimg} alt={item.title} />
                </div>
                <div className="bcard_content">
                  <div className="Press_heading_top">{item.pname}</div>
                  <div className="card_heading1">{item.title}</div>
                  <div className="card_date">{item.date}</div>
                </div>
              </div>
            </div>
          </div>
        );
      }
    });

    return (
      <ContentPage>
        <VideoPopup
          url={this.state.currentVideoLink}
          show={this.state.showVideo}
          onClose={this.toggleVideo}
          text={this.state.currentText}
        />
        <Meta
          title="Winpe | In the Press"
          image={
            "https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"
          }
          description="View news features on Winpe in leading business publications. For media inquiries, please write to info@winpeforum.com"
          location={location}
        />
        <div className="section__content">
          <div className="pview_wrapper">
            <div className="back_event">
              <Link to="/home">
                <i className="fa fa-arrow-left"> Back to Home</i>
              </Link>
            </div>
            <div className="pview_section">
              <div className="">
                <Heading title="In The Press" />
              </div>
              <div className="pview_intro_section">
                For media inquiries, please write to{" "}
                <a href="mailto:info@winpeforum.com">info@winpeforum.com</a>.
              </div>
              <div className="pview_mid_section">
                <div className="row">{pressJSX}</div>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

press.propTypes = {
  location: PropTypes.object,
};

export default press;



// WEBPACK FOOTER //
// ./src/pages/press/index.js